import React from 'react';
import { FaSun } from 'react-icons/fa';

const Navbar = () => {
  return (
    <div className="navbar">
      <div className="logo">
        <FaSun className="logo-icon" />
        TerraSyncInsights
      </div>
    </div>
  );
};

export default Navbar; 